import styled from 'styled-components'
import { device } from '../../styles/GlobalVariables'
import { globalStyles } from '../ottGlobalStyles'

export const OttTaboolaWrap = styled.div`
  width: 100%;
  padding-left: ${globalStyles.gridPadding.mobile};
  padding-right: ${globalStyles.gridPadding.mobile};
  position: relative;
  z-index: 1;

  ${device.small} {
    padding-left: ${globalStyles.gridPadding.desktop};
    padding-right: ${globalStyles.gridPadding.desktop};
  }
`
export const OttTaboolaProgramItemWidgetContainer = styled.div``
